import { NOME_PACOTE as NOME_COMMONS, VERSAO_PACOTE as VERSAO_COMMONS } from '@cei-ufg/ngx-arquitetura-cei-commons';
import {
  montarVersoesFrontend,
  NOME_PACOTE as NOME_FRONTEND,
  VERSAO_PACOTE as VERSAO_FRONTEND,
} from '@cei-ufg/ngx-arquitetura-cei-frontend';
import { NOME_PACOTE as NOME_SEGURANCA, VERSAO_PACOTE as VERSAO_SEGURANCA } from '@cei-ufg/ngx-cei-seguranca';
import { NOME_PACOTE as NOME_SSO, VERSAO_PACOTE as VERSAO_SSO } from '@cei-ufg/ngx-cei-sso-client';
import packageApp from '@cei-app/package.json';

/** Versões do frontend embutidas no bundle (fonte: package.json do app e das libs CEI). */
export const versoesFrontendAplicacao = montarVersoesFrontend({
  aplicacao: { nome: packageApp.name, versao: packageApp.version },
  componentes: [
    { nome: NOME_FRONTEND, versao: VERSAO_FRONTEND },
    { nome: NOME_COMMONS, versao: VERSAO_COMMONS },
    { nome: NOME_SSO, versao: VERSAO_SSO },
    { nome: NOME_SEGURANCA, versao: VERSAO_SEGURANCA },
  ],
});
